import { ODataSelect } from "@iconics/core";

export class Ontology extends ODataSelect
{
    public Name = "";
    public Description = "";
    public IsEnabled = "";
    public Id = "";
    public ["@odata.etag"] = "";

    public override toSelect(): string
    {
        return ''
    }
}
